<template>
  <div class="my-box-content-box">
    <div class="header">
      <div class="title">Notification</div>
    </div>
    <div class="myBox-mian">
      <div class="margin-goods">
        <div class="goods-img">
          <img src="@/assets/mybox/home/box2.png" />
        </div>
      </div>
      <div class="tip">
        <p>
          Your box was drawn <span class="text">iphone 16</span>, insufficient
          margins, forced closure
        </p>
      </div>
    </div>
    <div class="my-footer">
      <div class="margin" @click="UnBox">UnBox</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      margin: 208931.2,
    };
  },
  methods: {
    UnBox() {
      this.$emit("hide");
      this.$router.push({
        path: "UnBoxsDetails",
        query: { id: "000001", type: this.$store.state.staking.yourselfMadeBoxsDetails.label },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.my-box-content-box {
  height: 100%;
  width: 100%;
  padding: 0.3rem;
  background: #ffffff;
  border-radius: 15px;
  .header {
    .title {
      font-size: 28px;
      color: #303030;
      margin-top: 0.2rem;
    }
  }
  .myBox-mian {
    .tip {
      font-size: 14px;
      color: #909090;
      line-height: 19px;
      text-align: left;
      margin: 0.3rem 0;
      padding: 0 0.4rem;
      .text {
        color: #ae6bf7;
      }
    }
    .margin-goods {
      display: flex;
      justify-content: center;
      align-items: center;
      .goods-img {
        width: 2.8rem;
        height: 2.8rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .my-footer {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 0.3rem;
    .margin {
      width: 100%;
      border-radius: 25px;
      border: 1px solid #ae6bf7;
      height: 1rem;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 0.2rem;
      background: #ae6bf7;
    }
  }
}
</style>
